export const FILTER_TYPE_WTG_ENVELOPE = 'FILTER_TYPE_WTG_ENVELOPE'
export const FILTER_TYPE_WTG = 'FILTER_TYPE_WTG'
export const FILTER_TYPE_SUBPARK = 'FILTER_TYPE_SUBPARKG'
